import { ExtendTimeMutationVariables } from "../../../generatedQueries";
import {
  Event,
  ConstructorArgs as EventConstructorArgs,
} from "../../core/Event";
import { EventCategories } from "../../event-categories";
import { EventSubCategories } from "../../event-sub-categories";

export type Data = {
  mutationVariables: ExtendTimeMutationVariables;
};

export type ConstructorArgs = Data & Partial<EventConstructorArgs>;

class ExtendTimeRequest extends Event<Data> {
  public constructor(args: ConstructorArgs) {
    const { mutationVariables, ...baseArgs } = args;

    super({
      ...baseArgs,
      category: EventCategories.UI,
      subCategory: EventSubCategories.PARKABLE_TRANSACTIONS,
      type: `EXTEND_TIME.REQUEST`,
      data: {
        mutationVariables,
      },
    });
  }
}

export { ExtendTimeRequest };
